import ButtonMUI, { ButtonProps } from "@mui/material/Button";
import { SpacingProps } from "@mui/system";
import { useCallback } from "react";
import { DisplayKey } from "@/models/auth";
import { useAuthChecker } from "@/hooks/useAuthChecker";

export type MUIButtonProps = {
  label?: string;
  name: DisplayKey;
  onClick?: () => any;
};

export const AuthButton = (
  props: MUIButtonProps & ButtonProps & SpacingProps
) => {
  const { onClick, label, name } = props;
  const { authChecker } = useAuthChecker();
  const allowRoute = authChecker(name);
  const onClickButton = useCallback(() => {
    onClick && onClick();
  }, [onClick]);
  return (
    <ButtonMUI
      {...props}
      onClick={() => onClickButton()}
      variant="contained"
      disabled={!!props.disabled || !allowRoute}
    >
      {label}
    </ButtonMUI>
  );
};
